export const FREE_SHIPPING_MIN_AMOUNT = 35000;
export const FREE_SECOND_SHIPPING_MIN_AMOUNT = 70000;
export const DELIVERY_COST = 3490;
export const SECOND_DELIVERY_COST = 990;
export const GOOGLE_RATING = 4.8;
export const REFERRAL_DISCOUNT_AMOUNT = 5000;
export const MIN_AMOUNT_FOR_DISCOUNT_CREDITS = 10000;
